//@config
export default {
  profile: {
    azmoon_execute_combo: "v1/azmoon_execute_combo",
    person_research_interview: "v1/person/{0}/research_interview",
    research_interview: "v1/research_interview",
    person_skill: "v1/person/{0}/skill",
    skill: "v1/skill",
    permission_group_person: "v1/permission_group/{0}",
    person_cooperation: "v1/person/{0}/person_cooperation",
    person_azmoon: "v1/person/{0}/azmoon",
    person_job_experience: "v1/person/{0}/job",
    person_relation: "v2/person/{0}/person_relation",
    person_license: "v1/person/{0}/license",
    person_education: "v1/person/{0}/education",
    person_social: "v1/person/{0}/social",
    person_wife_relation: "v1/person/{0}/wife_relation",
    person_family_relation: "v1/person/{0}/family_relation",
    peron_free_course: "v1/person/{0}/free_course",
    person_address: "v1/person/{0}/address",
    person_article: "v1/person/{0}/article",
    person_allotment: "v1/person/{person_code}/allotment",
    user_code_generate_temp_password: "v1/user/{0}/generate_temp_password",
    parvandeh: "v1/parvandeh",
    user_parvandeh: "v1/user/{0}/parvandeh",
    person_financial: "v1/person/{0}/financial",
    generate_otp_code: "v1/generate_otp_code",
    parvandeh_status_count_incomplete: "v1/parvandeh/{0}/status",
    parvandeh_status_detail: "v1/parvandeh/{0}/status_detail",
    person_has_data: "v1/person/{0}/person_has_data",
    parvandeh_cancel: "v1/parvandeh_cancel",
    term_combo: "v1/term_combo",
    user_combo: "v1/user-combo?&search_txt={0}",
    refresh_parvandeh_status: "v1/parvandeh_status/calculate",
    person_inquiry: "v1/person/{0}/inquiry",
    person_inquiry_id: "v1/person/{0}/inquiry/{1}",
    company_combo: "v1/company/combo",
    term_state: "v1/term/{0}/term_state",
    term_state_id: "v1/term/{0}/term_state/{1}",
    edit_term_state: "v1/term/{0}/term_state/{1}",
    term_state_combo: "v1/term_state_combo",
    gate_combo: "v1/gate_combo",
    term_order: "v1/term/order",
    term_state_order: "v1/term_state/order",
    term_state_define_combo: "v1/term_state_define_combo",
    change_mobile: "v1/user/change_mobile",
    person_export_pdf: "v1/person/{0}/profile-preview",
    user_person_combo: "v1/user/person_combo?search_txt={0}",
    person_tags: "v1/person/{0}/tag",
    assign_role_permission: "v1/role/{0}/permission/{1}",
    parvandeh_hozeh_ghazayi_delete: "v1/parvandeh/{0}/hozeh_ghazayi",
    hozeh_ghazayi_detail_combo: "v1/hozeh_ghazayi_detail_combo",
    hozeh_ghazayi_province_combo: "v1/hozeh_ghazayi_province_combo",
    hozeh_ghazayi: "v1/hozeh_ghazayi",
    hozeh_ghazayi_id: "v1/hozeh_ghazayi/{0}",
    all_hozeh_ghazayi: "v1/all_hozeh_ghazayi",
    hozeh_ghazayi_by_admin: "v1/hozeh_ghazayi_by_admin",
    hozeh_ghazayi_reset: "v1/hozeh_ghazayi_reset/{0}",
    parvandeh_combo: "v1/parvandeh_combo",
    enum: "v1/enum",
    enum_id: "v1/enum/{0}",
    enum_detail: "v1/enum/{0}/detail",
    enum_type: "v1/enum/{type}",
    enum_grouped: "v1/enum/grouped",
    inquiry_list: "v1/inquiry",
    import_inquiry: "v1/import_inquiry",
    parvandeh_role_log: "v1/parvandeh/{0}/role_log",
    person_identity_change: "v1/person_identity_change",
    person_identity_change_code: "v1/person/{0}/identity_change",
    admin_identity_change_code: "v1/person/{0}/admin_identity_change",
    person_identity_change_id: "v1/person_identity_change/{0}",
    form_manual_register: "v1/form_manual_register",
    excel_manual_register: "v1/excel_manual_register",
    role_permission_copy: "v1/role/{0}/permission_copy",
    parvandeh_report: "v1/parvandeh/{0}/parvandeh_report",
    term_extra_profile: "v1/term_extra_profile/{0}",
    term_extra_attachment: "v1/term_extra_attachment/{0}",
    report_access: "v1/report_access",
    report_access_id: "v1/report_access/{0}",
    report_settings: "v1/report_settings",
    enum_editable: "v1/enum_editable",
    province: "v1/filter/province",
    province_township: "v1/province/{0}/township",
    township_section: "v1/township/{0}/section",
    parvandeh_archive: "v1/parvandeh_archive",
    user_id: "v1/user/{0}",
    userIdChangeInfo: "v1/user/{0}/change_info",
    whats_new: "v1/whats_new",
    whats_new_id: "v1/whats_new/{0}",
    userChangePass: "v1/user-change-pass",
    userChangeInfo: "v1/user-change-info",
    userChangeMobile: "v1/user-change-mobile",
    term: "v1/term",
    term_id: "v1/term/{0}",
    term_register_code: "v1/term/{0}/term_register_code",
    term_register_code_id: "v1/term/{0}/term_register_code/{1}",
    import_term_register_code: "v1/term/{0}/import_term_register_code",
    change_user_pass: "v1/user/{0}/change_pass",
    personTeachingExperiences: "v1/fa/person/{0}/teaching-experience",
    personTeachingExperience: "v1/fa/person/{0}/teaching-experience/{1}",
    parvandehId: "v1/parvandeh/{0}",
    parvandehRole: "v1/parvandeh/{0}/role",
    v2: {
      parvandeh: "v2/parvandeh",
      parvandeh_archive: "v2/parvandeh_archive",
      term: "v2/term/{0}",
      term_id_register: "v2/term/{0}/register",
      user_id: "v2/user/{0}",
      importManualRegister: "v2/fa/import-manual-register",
      termImportRegisterCode: "v2/fa/term/{0}/import-term-register-code",
    },
  },
};
